"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonTravelBehaviorConfirmNextSection = exports.personNoSchoolTripReasonSpecify = exports.personNoSchoolTripReason = exports.personNoSchoolTripIntro = exports.personNoWorkTripReasonSpecify = exports.personNoWorkTripReason = exports.personNoWorkTripIntro = exports.buttonSwitchPerson = exports.activePersonTitle = void 0;
const defaultInputBase = __importStar(require("evolution-frontend/lib/components/inputs/defaultInputBase"));
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const choices = __importStar(require("../../common/choices"));
const customConditionals = __importStar(require("../../common/customConditionals"));
const customWidgets = __importStar(require("./customWidgets"));
exports.activePersonTitle = customWidgets.activePersonTitle;
exports.buttonSwitchPerson = customWidgets.buttonSwitchPerson;
exports.personNoWorkTripIntro = customWidgets.personNoWorkTripIntro;
exports.personNoWorkTripReason = Object.assign(Object.assign({}, defaultInputBase.inputSelectBase), { path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.noWorkTripReason', twoColumns: false, containsHtml: false, label: (t) => t('travelBehavior:household.persons.{_activePersonId}.journeys.{_activeJourneyId}.noWorkTripReason'), choices: choices.noWorkTripReasonChoices, conditional: customConditionals.shouldAskForNoWorkTripReasonCustomConditional, validations: validations.requiredValidation });
exports.personNoWorkTripReasonSpecify = customWidgets.personNoWorkTripReasonSpecify;
exports.personNoSchoolTripIntro = customWidgets.personNoSchoolTripIntro;
exports.personNoSchoolTripReason = Object.assign(Object.assign({}, defaultInputBase.inputSelectBase), { path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.noSchoolTripReason', twoColumns: false, containsHtml: false, label: (t) => t('travelBehavior:household.persons.{_activePersonId}.journeys.{_activeJourneyId}.noSchoolTripReason'), choices: choices.noSchoolTripReasonChoices, conditional: customConditionals.shouldAskForNoSchoolTripReasonCustomConditional, validations: validations.requiredValidation });
exports.personNoSchoolTripReasonSpecify = customWidgets.personNoSchoolTripReasonSpecify;
exports.buttonTravelBehaviorConfirmNextSection = Object.assign(Object.assign({}, defaultInputBase.buttonNextBase), { path: 'travelBehavior.save', label: (t) => t('travelBehavior:travelBehavior.save') });
